// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const AngleDownSmall: React.FC<{ width?: number; height?: number }> = ({ width = 9, height = 5 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 9 5">
            <path
                fill="currentColor"
                d="M3.96 4.8a.824.824 0 0 0 1.08 0l3.75-3.572A.73.73 0 0 0 8.79.2a.824.824 0 0 0-1.08 0L4.5 3.28 1.29.201A.824.824 0 0 0 .21.2a.73.73 0 0 0 0 1.027l3.75 3.571Z"
            />
        </svg>
    );
};

export default React.memo(AngleDownSmall);
